export default "__VITE_ASSET__BMRVu7u1__"